export default "__VITE_ASSET__2sOL4CqE__"